// extracted by mini-css-extract-plugin
export default {"dropzone":"UploadFileModal-module__dropzone___iWxmf","dropzone_active":"UploadFileModal-module__dropzone_active___BDGnQ"};